var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.297,
    height: 79.295,
    viewBox: "0 0 79.297 79.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(-911.96 -612.488)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.083,
    cy: 37.083,
    r: 37.083,
    transform: "translate(914.526 615.052)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccbcb",
    d: "M951.61 691.783a39.648 39.648 0 1 1 39.647-39.647 39.693 39.693 0 0 1-39.647 39.647zm0-74.167a34.52 34.52 0 1 0 34.518 34.52 34.558 34.558 0 0 0-34.518-34.52z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M966.381 668.257h-6.469L951 656.28l-8.911 11.977h-6.468l12.144-16.325-11.445-15.385h6.532l8.171 11.012 8.192-11.012h6.468l-11.431 15.363z",
    transform: "translate(-911.96 -612.488)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close-modal.98597225.svg";
export { ForwardRef as ReactComponent };